export const adminInvitationsEndpoints = {
    base: "/api/admin/invitations",
    byId: (id: number | string): string => `/api/admin/invitations/${id}`,
} as const;

export const adminInvitationsQueryParams = { status: "status" } as const;

export const invitationStatusValues = {
    accepted: "accepted",
    cancelled: "cancelled",
    expired: "expired",
    pending: "pending",
} as const;
